"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.min = exports.divDown = exports.preciseDivCeilInt = exports.preciseDivCeil = exports.preciseDiv = exports.preciseMulCeilInt = exports.preciseMulCeil = exports.preciseMul = void 0;
var constants_1 = require("../constants");
var preciseMul = function (a, b) {
    return a.mul(b).div(constants_1.PRECISE_UNIT);
};
exports.preciseMul = preciseMul;
var preciseMulCeil = function (a, b) {
    if (a.eq(0) || b.eq(0)) {
        return constants_1.ZERO;
    }
    return a.mul(b).sub(1).div(constants_1.PRECISE_UNIT).add(1);
};
exports.preciseMulCeil = preciseMulCeil;
var preciseMulCeilInt = function (a, b) {
    if (a.eq(0) || b.eq(0)) {
        return constants_1.ZERO;
    }
    if (a.gt(0) && b.gt(0) || a.lt(0) && b.lt(0)) {
        return a.mul(b).sub(1).div(constants_1.PRECISE_UNIT).add(1);
    }
    else {
        return a.mul(b).add(1).div(constants_1.PRECISE_UNIT).sub(1);
    }
};
exports.preciseMulCeilInt = preciseMulCeilInt;
var preciseDiv = function (a, b) {
    return a.mul(constants_1.PRECISE_UNIT).div(b);
};
exports.preciseDiv = preciseDiv;
var preciseDivCeil = function (a, b) {
    if (a.eq(0) || b.eq(0)) {
        return constants_1.ZERO;
    }
    return a.mul(constants_1.PRECISE_UNIT).sub(1).div(b).add(1);
};
exports.preciseDivCeil = preciseDivCeil;
var preciseDivCeilInt = function (a, b) {
    var result = a.mul(constants_1.PRECISE_UNIT).div(b);
    if (result.mul(b).eq(a.mul(constants_1.PRECISE_UNIT))) {
        return result;
    }
    if ((a.gt(0) && b.gt(0)) || (a.lt(0) && b.lt(0))) {
        return result.add(1);
    }
    else {
        return result.sub(1);
    }
};
exports.preciseDivCeilInt = preciseDivCeilInt;
var divDown = function (a, b) {
    var result = a.div(b);
    if (a.lt(0) && b.gt(0) && !a.mod(b).isZero()) {
        result = result.sub(1);
    }
    else if (a.gt(0) && b.lt(0) && !a.mod(b.mul(-1)).isZero()) {
        result = result.sub(1);
    }
    return result;
};
exports.divDown = divDown;
var min = function (valueOne, valueTwo) {
    return valueOne.lt(valueTwo) ? valueOne : valueTwo;
};
exports.min = min;
//# sourceMappingURL=mathUtils.js.map